<div class="sac-transports"
  [ngStyle]="{ 'width.px': listWidth , 'min-width.px': listWidth , 'max-width.px': listWidth }">
  <sc-flex fitHeight stretchContent vertical>
    <ng-container *ngIf="featureMovingOrderActive||featurePlannedTransportsActive">
      <sc-flex>
        <sc-content-spacer grow></sc-content-spacer>
        <sc-action-icon (click)="managePlannedAssignments()" *ngIf="featurePlannedTransportsActive"
          iconClass="fa-truck-clock"
          [disabled]="selection?.station?.stationType !== stationType.WORKING_AREA || !selection?.station?.stationUsage?.plannedTransportAssignmentPossible">
        </sc-action-icon>
        <sc-content-spacer [grow]="false" *ngIf="featureMovingOrderActive"></sc-content-spacer>
        <sc-action-icon (click)="createMovingOrder()" *ngIf="featureMovingOrderActive"
          [disabled]="!selection?.station?.stationUsage?.createMovementOrderPossible" iconClass="fa-truck-arrow-right">
        </sc-action-icon>
      </sc-flex>
      <sc-content-spacer vertical></sc-content-spacer>
    </ng-container>
    <sc-flex-fitting-content vertical>
      <sc-scroll-pane>
        <div class="transport-group" *ngFor="let transportGroup of transportGroups">
          <ng-container *ngIf="transportGroup.transports.length > 0 || transportGroup.key === 'transports'">

            <sc-sub-title>
              <sc-dictionary-label [dictionaryKey]="transportGroup.nameDictionaryKey"></sc-dictionary-label>
            </sc-sub-title>

          </ng-container>

          <div class="no-transport-hint"
            *ngIf="transportGroup.transports.length === 0 && transportGroup.key === 'transports'">
            <sc-dictionary-label
              dictionaryKey="tmc-yard.ui.control.sac-client.sac-transports.empty"></sc-dictionary-label>
          </div>

          <sc-content-spacer vertical></sc-content-spacer>

          <div class="transport-list">

            <ng-container *ngFor="let transport of transportGroup.transports">

              <app-transport-list-entry [transport]="transport" [dashboardContext]="dashboardContext"
                [selected]="selectedTransportId != null && transport.id === selectedTransportId && selectedTransportGroupKey === transportGroup.key"
                (click)="setSelectedTransport(transportGroup, transport)"></app-transport-list-entry>

              <ng-container *ngIf="selectedTransportId != null && transport.id === selectedTransportId">
                <app-transport-details-list-entry [transport]="transport" [dashboardContext]="dashboardContext"
                  [station]="selection.station" [stationSet]="selection.stationSet"></app-transport-details-list-entry>
              </ng-container>

              <sc-content-spacer vertical [half]="true"></sc-content-spacer>
            </ng-container>

          </div>

          <sc-content-spacer vertical></sc-content-spacer>

        </div>
      </sc-scroll-pane>
    </sc-flex-fitting-content>
  </sc-flex>
</div>
